/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import TableRow from "../../Helpers/Table/TableRow";
import Empty from "../../Helpers/Empty/Empty";
import TableActions from "../../Helpers/Table/TableActions2";
import CategoryPopup from "./popup/CategoryPopup";
import CategoryDeletePopup from "./popup/CategoryDeletePopup";
import { CategoryEditForm } from "./CategoryEditForm";

export default function CategoriesTableBody({ data, refetch }) {
  const [showId, setShowId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isDeleted, setIsDeleted] = useState(false);
  const [editId, setEditId] = useState("");
  const onClose = () => {
    setDeleteId("");
    setShowId("");
    setEditId("");
  };

  useEffect(() => {
    if (isDeleted) {
      refetch();
      setIsDeleted(false);
    }
  }, [isDeleted]);

  if (data === "No Categories Found!")
    return (
      <Empty
        title="No Categories Found"
        subtitle="Create your Categories now!"
      />
    );

  return (
    <>
      {data?.map((i) => {
        return (
          <div key={i.id} className="table-row">
            <TableRow value={i.name} style="table-element-code ps-0" />
            <TableRow value={i.code} />
            <TableRow
              value={i.description ? i.description : "- - - -"}
              valuestyle={"truncate-2-lines"}
            />
            <TableActions
              setShowId={setShowId}
              setDeleteId={setDeleteId}
              setEditId={setEditId}
              data={i}
              button1="Eye"
              button2="Edit"
              button3="Delete"
            />
          </div>
        );
      })}
      {!!deleteId && (
        <CategoryDeletePopup
          id={deleteId.id}
          deleteType={deleteId.name}
          onClose={onClose}
          setIsDeleted={setIsDeleted}
        />
      )}
      {!!showId && (
        <CategoryPopup
          id={showId.id}
          data={showId}
          onClose={onClose}
          title={showId.name}
        />
      )}
      {!!editId && (
        <CategoryEditForm
          id={editId.id}
          data={editId}
          onClose={onClose}
          title={editId.name}
          refetch={refetch}
        />
      )}
    </>
  );
}
